module.exports = __webpack_public_path__ + "img/3.2af4bb94.jpg";